import * as React from 'react';
import { CardHeader, IconButton, Skeleton } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import { makeStyles } from '@mui/styles';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles(() => ({
  title: {
    wordBreak: 'break-word',
  },
  actions: {
    marginLeft: 'auto',
  },
}));

interface Props {
  loading: boolean;
  title: string;
  onEditClick: () => void;
}

const CardTitle: React.FC<Props> = ({ loading, title, onEditClick }: Props) => {
  const classes = useStyles();
  const { t } = useTranslation('common');
  const editButton = (
    <IconButton
      className={classes.actions}
      title={t('edit')}
      color="secondary"
      onClick={onEditClick}
    >
      <EditIcon />
    </IconButton>
  );
  return (
    <CardHeader
      classes={{ title: classes.title }}
      action={loading ? <Skeleton>{editButton}</Skeleton> : editButton}
      title={
        loading ? (
          <Skeleton>
            <span>{title}</span>
          </Skeleton>
        ) : (
          title
        )
      }
    />
  );
};

export default CardTitle;
